<template>
    <div :style="container_style" :class="container_class">
        <div @click.prevent="showModal" :style="btn_container_style" :class="btn_container_class">
            <button v-if="btn_type=='btn'" type="button" class="btn make-offer-btn">{{btnCaption}}</button>
            <div v-if="btn_type=='div'" class="make-offer-find-task">
                <a href="#">{{btnCaption}}</a>
            </div>
            <a v-if="btn_type=='a'" href="#">{{btnCaption}}</a>
        </div>
        <vue-modal
                v-if="show_modal"
                modal_title="Edit Task"
                container_style="min-width:60%;height:500px;overflow:hidden;"
                body_container_style="min-width:60%;height:500px;overflow-y:auto;text-align:left;"
                body_container_class
                header_container_class
                footer_container_class
                @close="hideModal"
        >
            <template v-slot:header>
                <div
                        class="text-light text-center"
                        style="background:#12895f;padding: 15px;margin:0;font-size:18px;"
                >{{ Title }}
                </div>
            </template>
            <template v-slot:body>
                <div class="alert alert-info">
                    <!--          <div style="display:inline-block;" class="text-danger">{{ note_title }}</div>-->
                    <div style="display:inline-block;">{{ note }}</div>
                </div>
                <div style="margin:15px;">
                    <div style="margin-bottom:15px;font:weight:bold;font-size:16px;">Offer:</div>
                    <div class="row">
                        <div class="col col-lg-6 col-md-6 col-sm-12">
                            <div class="mt-3">
                                <label style="display:block">
                                    <input type="checkbox" id="offer_after_inspection" v-model="offer_after_inspection" 
                                    style="margin-right: 4px;">
                                    offer after inspection
                                </label>
                                <label for="amount" style="margin: 0 5px 0 0">offer amount:</label>
                                <money
                                        id="amount"
                                        v-model="amount"
                                        input_class
                                        input_style="border: 1px solid #ccc;border-radius: 3px;padding: 10px 19px;color:#555;"
                                ></money>
                            </div>
                        </div>
                        <div class="col col-lg-6 col-md-6 col-sm-12" style="padding-top:18px">
                            <div class="mt-3">
                                <label for="days" style="margin: 0 5px 0 0">Delivery in:</label>
                                <input
                                        id="days"
                                        name="days"
                                        type="number"
                                        min="0"
                                        v-model="days"
                                        placeholder="Number of Days"
                                        style="border: 1px solid #ccc;border-radius: 3px;padding: 10px 19px;color:#555;width: 222px;"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col col-12">
                            <label for="message" style="margin: 20px 0 6px 0;">Message:</label>
                            <textarea
                                    id="message"
                                    v-model="message"
                                    rows="6"
                                    style="border: 1px solid #ccc;border-radius: 5px;padding: 10px 19px;color:#555;width:100%;"
                                    placeholder="Type your message here"
                            ></textarea>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col col-6">
                            <div v-if="showMakeAnOfferBtn" @click="post" class="btn btn-dark-blue">{{btnCaption}}</div>
                            <div @click="hideModal" class="btn btn-dark">Cancel</div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <div></div>
            </template>
        </vue-modal>
    </div>
</template>

<script>
    import VueModal from "./../../VueModal";
    import Money from "./../../Money";

    export default {
        name: "make-offer",
        props: {
            btn_type: {
                type: String,
                default: "btn"
            },
            task_id: {
                type: [String, Number],
                required: true
            },
            user_id: {
                type: [String, Number],
                default: ""
            },
            btn_container_style: {
                type: String,
                default: ""
            },
            btn_container_class: {
                type: String,
                default: ""
            },
            container_style: {
                type: String,
                default: ""
            },
            container_class: {
                type: String,
                default: ""
            },
            note: {
                type: String,
                default: `Send your competitive offer to the customer and wait for it to be accepted.`
            },
            title: {
                type: String,
                default: "Make an Offer"
            },
            note_title: {
                type: String,
                default: `Note: `
            }
        },
        components: {
            VueModal,
            Money
        },
        data() {
            return {
                show_modal: false,
                amount: 0,
                offer_after_inspection: false,
                days: null,
                message: null,
                showMakeAnOfferBtn: true,
                btnCaption: "Make an Offer",
                Title: this.title
            };
        },
        created() {
            this.create_offer();
            this.enable_or_disable_amount()
        },
        methods: {
            create_offer() {
                    if (
                    this.user_id != null &&
                    this.user_id != undefined &&
                    this.user_id != ""
                ) {
                    let self = this;
                    self.$Progress.start();
                    axios({
                        method: "get",
                        url:
                            "/api/v1/offer/search?api_token=" +
                            window.api_token +
                            "&task_id=" +
                            self.task_id +
                            "&user_id=" +
                            self.user_id
                    })
                        .then(function (res) {
                            if (res.data.ok) {
                                self.$Progress.finish();
                                if (res.data.data) {
                                    self.amount = res.data.data.amount;
                                    self.offer_after_inspection = res.data.data.offer_after_inspection;
                                    self.message = res.data.data.message;
                                    self.days = res.data.data.days;
                                    self.btnCaption = "Update Offer";
                                    self.Title = "Update Offer";
                                }
                            } else {
                                self.$Progress.finish();
                            }
                            self.showMakeAnOfferBtn = true;
                        })
                        .catch(function (err) {
                            self.$Progress.fail();
                            console.log(err.response.data.message);
                        });
                }
                
            },
            post: function () {
                this.showMakeAnOfferBtn = false;
                this.$Progress.start();
                let self = this;
                let price = this.amount;
                price = price.split(",").join("");
                price = price.split("$").join("");
                let data = {
                    amount: price,
                    offer_after_inspection: this.offer_after_inspection,
                    days: this.days,
                    message: this.message,
                    task_id: this.task_id
                };
                axios({
                    method: "post",
                    url: "/dashboard/offer",
                    data
                })
                    .then(function (res) {
                        if (res.data.ok) {
                            self.$Progress.finish();
                            self.$toast.success(res.data.msg);
                            self.create_offer()

                            setTimeout(function () {
                                self.show_modal = false;
                            }, 2000);

                        } else {
                            self.$toasted.show(res.data.msg, {
                                theme: "bubble",
                                position: "top-center",
                                duration: 5000
                            });
                            self.$Progress.finish();
                        }
                        // self.showMakeAnOfferBtn = true;
                    })
                    .catch(function (err) {
                        self.$Progress.fail();
                        self.showMakeAnOfferBtn = true;
                        self.$Progress.fail();
                        if (err.response.status == 422) {
                            self.errors = err.response.data.errors;
                            console.log(self.errors);
                            for (let error in self.errors) {
                                self.$toast.error(self.errors[error][0]);
                            }
                        } else if (err.response.status == 403) {
                            self.$toast.error(err.response.data.message);
                        } else {
                            console.log(err.response.data.message);
                        }
                    });
            },
            
            showModal: function () {
                this.show_modal = true;
            },
            hideModal: function () {
                this.show_modal = false;
            },
            enable_or_disable_amount: function () {
                let self = this
                setInterval(function () {
                    if(self.offer_after_inspection){
                        $('#amount').prop('disabled', true);
                        $('#amount').css('background', '#8080804f');
                        self.amount = '0';
                    }else{
                        $('#amount').prop('disabled', false);
                        $('#amount').css('background', '#fff');
                    }
                }, 200);
      
            }
          
        }
    };
</script>
